import sectionIconsOpacity from './sectionIconsConsts';

const AccountDetailsIcon = ({ isSelected }: { isSelected: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g
      id="user"
      fill={isSelected ? '#ED3984' : '#212231'}
      fillOpacity={isSelected ? sectionIconsOpacity.selected : sectionIconsOpacity.unselected}
    >
      <path
        id="Vector (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.72039 12.887C4.50179 12.1056 5.5616 11.6666 6.66667 11.6666H13.3333C14.4384 11.6666 15.4982 12.1056 16.2796 12.887C17.061 13.6684 17.5 14.7282 17.5 15.8333V17.5C17.5 17.9602 17.1269 18.3333 16.6667 18.3333C16.2064 18.3333 15.8333 17.9602 15.8333 17.5V15.8333C15.8333 15.1703 15.5699 14.5344 15.1011 14.0655C14.6323 13.5967 13.9964 13.3333 13.3333 13.3333H6.66667C6.00363 13.3333 5.36774 13.5967 4.8989 14.0655C4.43006 14.5344 4.16667 15.1703 4.16667 15.8333V17.5C4.16667 17.9602 3.79357 18.3333 3.33333 18.3333C2.8731 18.3333 2.5 17.9602 2.5 17.5V15.8333C2.5 14.7282 2.93899 13.6684 3.72039 12.887Z"
      />
      <path
        id="Vector (Stroke)_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 3.33329C8.61933 3.33329 7.50004 4.45258 7.50004 5.83329C7.50004 7.214 8.61933 8.33329 10 8.33329C11.3808 8.33329 12.5 7.214 12.5 5.83329C12.5 4.45258 11.3808 3.33329 10 3.33329ZM5.83337 5.83329C5.83337 3.53211 7.69885 1.66663 10 1.66663C12.3012 1.66663 14.1667 3.53211 14.1667 5.83329C14.1667 8.13448 12.3012 9.99996 10 9.99996C7.69885 9.99996 5.83337 8.13448 5.83337 5.83329Z"
      />
    </g>
  </svg>
);

export default AccountDetailsIcon;
